import chatbotRegex from '~/utils/chatbot-regex';

/**
 * Process the message object to get the [options] to be populated into ChatOptions.vue
 * @param {object} data - message object received from zopim
 * @returns {object}
 */
export const stripOptions = data => {
  if (!data.msg) return data;

  const message = { ...data };
  const splittedMsgs = message.msg.split('[option]');
  message.msg = splittedMsgs[0].trim();
  const options = splittedMsgs.filter((_, i) => i !== 0).map(opt => opt.trim());
  if (options.length) message.options = [...message.options, ...options];
  return message;
};

/**
 * Process the message object to get the [options] to be populated into ChatOptions.vue
 * @param {object} data - message object received from zopim
 * @returns {boolean}
 */
export const isChatbotCommand = data => {
  if (!data.msg) return false;
  return !!data.msg.match(chatbotRegex);
};
